var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonReflection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.25) translate(-23.5 -17.5)",
    stroke: "currentColor",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 44H75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 23L75 44L53 65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 87H68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 67L68 87L90 108"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonReflection);
export default __webpack_public_path__ + "static/media/lesson-reflection.e5ef08519b4402b207e75b09e98a52ab.svg";
export { ForwardRef as ReactComponent };